<nz-input-group
  class="w-1/2 pb-5"
  nzSearch
  nzSize="large"
  [nzAddOnAfter]="suffixIconButton"
  ><input
    #searchInput
    [(ngModel)]="searchValue"
    type="text"
    nz-input
    placeholder="Suchen Sie hier nach Namen von Personen"
    (keydown.enter)="onSearch($event)"
  />
</nz-input-group>
<ng-template #suffixIconButton>
  <button (click)="onSearch($event)" nz-button nzType="primary" nzSearch>
    <span nz-icon nzType="search"></span>
  </button>
</ng-template>
<ng-container *ngIf="persons$ | async as persons">
  <nz-table
    #filterTable
    [nzData]="persons"
    nzSize="middle"
    nzTableLayout="auto"
    [nzScroll]="persons.length ? { x: '100%' } : {}"
  >
    <thead>
      <tr>
        <th nzCustomFilter [nzSortFn]="listOfSortFilterOptions.sortByFirstName">
          Name
        </th>
        <th nzCustomFilter [nzSortFn]="listOfSortFilterOptions.sortByLastName">
          Nachname
        </th>
        <th>Geschlecht</th>
        <th>Gruppe</th>
        <th>Spinde</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let data of filterTable.data"
        (click)="onPersonClick(data)"
        class="clickable-row"
      >
        <td>{{ data.vorname }}</td>
        <td>{{ data.name }}</td>
        <td>{{ data.geschlecht }}</td>
        <td>{{ data.gruppe ?? 'Keine Gruppe' }}</td>
        <td>{{ data.spindeString }}</td>
      </tr>
    </tbody>
  </nz-table>
  <nz-spin *ngIf="loading" nzSize="large" nzTip="Lade Kleidung..."> </nz-spin>
</ng-container>
